<mat-list-item [class]="indent" class="va-dropdown-list-item" [ngClass]="{ first: first }">
  <div class="va-dropdown-list-item__grouping">
    <div class="va-dropdown-list-item__icon-title">
      <va-icon
        *ngIf="!secondaryIconUrl && !secondaryIconName; else dualIcon"
        mat-list-avatar
        [iconName]="title"
        [iconUrl]="iconUrl"
        [diameter]="40"
      ></va-icon>
      <div class="va-dropdown-list-item__title-wrapper">
        <div class="va-dropdown-list-item__title-container">
          <span class="va-dropdown-list-item__title">
            {{ title }}
            <ng-container *ngIf="editionName">&nbsp;|&nbsp;{{ editionName }}</ng-container>
            <span *ngIf="previousEditionName" class="va-dropdown-list-item__title-descriptor">
              {{ 'FRONTEND.SALES_UI.CHANGES_EDITION_FROM' | translate : { previousEditionName: previousEditionName } }}
            </span>
            <span *ngIf="titleDescriptor" class="va-dropdown-list-item__title-descriptor">
              {{ titleDescriptor }}
            </span>
          </span>
          <span class="package-dropdown-font">{{ subtitle }}</span>
        </div>
      </div>
    </div>
    <div class="va-dropdown-list-item__status-wrapper">
      <div *ngIf="!statusItem" class="va-dropdown-list-item__layout">
        <p class="va-dropdown-list-item__layout va-dropdown-list-item__notice">
          {{ description }}
        </p>
        <ng-container *ngIf="enableDropdown; then dropdownButton; else menu"></ng-container>
      </div>
      <div *ngIf="statusItem" class="va-dropdown-list-item__layout va-dropdown-list-item__status">
        <div [ngClass]="calculateClassFromStatus(statusItem.status)">
          <mat-icon>{{ statusItem.icon }}</mat-icon>
        </div>
        <p class="va-dropdown-list-item__notice" #errorRef [ngClass]="calculateClassFromStatus(statusItem.status)">
          {{ statusItem.text | translate }}
          {{ statusText(statusItem.status) ? ' - ' + (statusText(statusItem.status) | translate) : '' }}
          <span *ngIf="statusItem.failureDetails">
            -
            <span [innerHTML]="statusItem.failureDetails"></span>
          </span>
        </p>
        <ng-container *ngIf="enableDropdown; then dropdownButton; else menu"></ng-container>
      </div>
    </div>
  </div>
</mat-list-item>

<ng-template #dropdownButton>
  <button *ngIf="enableDropdown" mat-icon-button type="button" (click)="toggleItem()">
    <mat-icon
      mat-list-icon
      class="dropdown-icon"
      [ngClass]="{
        'dropdown-icon-rotate-up': !toggleValue,
        'dropdown-icon-rotate-down': toggleValue
      }"
    >
      keyboard_arrow_down
    </mat-icon>
  </button>
</ng-template>

<ng-template #menu>
  <div class="va-dropdown-list-item__menu-button" *ngIf="menuItems.length > 0 && showMenuItems">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item *ngFor="let menuItem of menuItems" (click)="menuItemClick(menuItem)">
        <mat-icon *ngIf="!!menuItem.icon">{{ menuItem.icon }}</mat-icon>
        {{ menuItem.label | translate }}
      </button>
    </mat-menu>
  </div>
</ng-template>

<ng-template #dualIcon>
  <div class="dual-icon">
    <va-icon mat-list-avatar [iconUrl]="iconUrl" [iconName]="title" [diameter]="40"></va-icon>
    <va-icon
      mat-list-avatar
      class="secondary-icon"
      [iconUrl]="secondaryIconUrl"
      [diameter]="20"
      [iconName]="secondaryIconName"
    ></va-icon>
  </div>
</ng-template>
